import { apiClient } from 'shared/api';

import { ListingSearchResponse } from '../model/dto';

export const getWhereSearch = async (value: string): Promise<ListingSearchResponse> => {
  const { data } = await apiClient.get('/listing/search', {
    ...(value && { value }),
  });

  return data.result;
};

export const getRoomCount = async (): Promise<number> => {
  const { data } = await apiClient.get('/listing/roomCount');

  return data.result;
};
